<div class="modal-header">
    <h4 class="modal-title">{{ options.title }}</h4>
</div>
<div class="modal-body">
    <p [innerHTML]="options.message | safeHTML"></p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="close()">
        {{ 'close' | label: 'general' | async }}
    </button>
</div>